import { render, staticRenderFns } from "./giftcards-items-form.vue?vue&type=template&id=628a7080&scoped=true&"
import script from "./giftcards-items-form.vue?vue&type=script&lang=js&"
export * from "./giftcards-items-form.vue?vue&type=script&lang=js&"
import style0 from "./giftcards-items-form.vue?vue&type=style&index=0&id=628a7080&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a7080",
  null
  
)

export default component.exports